import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../../../../core/layout/Dialog';
import Separator from '../../../../../core/layout/Separator';
import Row from '../../../../../core/layout/Row';
import Column from '../../../../../core/layout/Column';
import get from 'lodash/get';
import FormButtons from '../../../../../core/form/FormButtons';
import TextInput from '../../../../../core/form/TextInput';
import Divider from '../../../../../core/layout/Divider';

const CreateUnitItemDraftDialog = (props) => (
  <Dialog title="Create Draft" isOpen={props.isOpen} onCancel={props.onCancel} actions={null} width={1000}>
    <div>
      <b>Module</b>: <span>{props.module.name}</span>
    </div>
    <Separator size="xxs" />
    <div>
      <b>Unit</b>: <span>{props.unit.name}</span>
    </div>
    <Separator size="xxs" />
    <div>
      <b>Order</b>: <span>{props.unitItem && props.unitItem.order}</span>
    </div>
    <Separator size="xxs" />
    <div>
      <b>Group</b>:{' '}
      <span>{props.unitItem && ['', 'Default', 'First Review', 'Second Review'][props.unitItem.group]}</span>
    </div>
    <Separator size="xxs" />
    <div>
      <b>Text</b>: <span>{props.unitItem && props.unitItem.item.text}</span>
    </div>
    <Separator size="sm" />
    <Divider title="" />
    <form
      onSubmit={(event) => {
        event.preventDefault();
        props.onSubmit();
      }}
    >
      <Row>
        <Column size={12}>
          <TextInput
            required
            label="What is the change reason?"
            fieldType="textarea"
            disabled={props.submitting || props.disabled}
            value={get(props.values, 'draftCreationReason', '')}
            onChange={(value) => props.onChange('draftCreationReason', value)}
            errorText={get(props.errors, 'draftCreationReason', '')}
            textAreaRows="4"
          />
        </Column>
      </Row>
      <Separator size="xs" />
      <FormButtons
        confirmLabel="Create"
        isDisabled={props.submitting || !props.isDirty()}
        isSubmitting={props.submitting}
        onReset={props.onCancel}
      />
    </form>
  </Dialog>
);

CreateUnitItemDraftDialog.propTypes = {
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  module: PropTypes.object.isRequired,
  unit: PropTypes.object.isRequired,
  unitItem: PropTypes.object.isRequired,
  onSubmit: PropTypes.func,
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  isDirty: PropTypes.func,
};

CreateUnitItemDraftDialog.defaultProps = {
  isOpen: false,
};

export default CreateUnitItemDraftDialog;
